import { z } from 'zod'

import ZBaseAction from './base'

const ZUnsubscribeAllAction = ZBaseAction.extend({
  unsubscribeAll: z.object({}),
})

export default ZUnsubscribeAllAction
